import axios from "@/axios.js";
import constants from "@/constants.js";

export default {
  async createIntegrationLink(_, playload) {
    try {
      const resObj = await axios.post(`${constants.gatewayServiceUrl}/mergedev/integration/magic-link`, playload);
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
};
